import { createSlice } from "@reduxjs/toolkit";
import {
  getSettlementPrices,
  addNewSettlementPrice,
  updateSettlementPrice,
  deleteSettlementPrice,
  getSettlementPriceById,
} from "./thunk";

export const initialState = {
  settlementPrices: [],
  error: {},
  selectedSettlementPrice:null,
  isSettlementPriceSuccess: false,
  isSettlementPriceCreated: false,
};

const settlementPricesSlice = createSlice({
  name: "SettlementPricesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    
    // Fetch settlement prices
    builder.addCase(getSettlementPrices.fulfilled, (state, action) => {
      state.settlementPrices = action.payload; // Assuming `action.payload` contains settlement price data
      state.isSettlementPriceSuccess = true;
      state.error = null;
    });

    builder.addCase(getSettlementPrices.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch settlement prices";
      state.isSettlementPriceSuccess = false;
    });

    // Fetch a single settlement price by ID
    builder.addCase(getSettlementPriceById.fulfilled, (state, action) => {
      state.selectedSettlementPrice = action.payload; // Set the selected settlement price
      state.error = null;
    });

    builder.addCase(getSettlementPriceById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch settlement price by ID";
    });

    // Add new settlement price
    builder.addCase(addNewSettlementPrice.fulfilled, (state, action) => {
      state.settlementPrices.push(action.payload); // Add the new settlement price to the list
      state.isSettlementPriceCreated = true;
      state.error = null;
    });

    builder.addCase(addNewSettlementPrice.rejected, (state, action) => {
      state.error = action.payload || "Failed to add settlement price";
      state.isSettlementPriceCreated = false;
    });

    // Update settlement price
    builder.addCase(updateSettlementPrice.fulfilled, (state, action) => {
      state.settlementPrices = state.settlementPrices.map((settlementPrice) =>
        settlementPrice.id === action.payload.id
          ? { ...settlementPrice, ...action.payload }
          : settlementPrice
      );
      state.error = null;
    });
    

    builder.addCase(updateSettlementPrice.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update settlement price";
    });

    // Delete settlement price
    builder.addCase(deleteSettlementPrice.fulfilled, (state, action) => {
      state.settlementPrices = state.settlementPrices.filter(
        (settlementPrice) => settlementPrice.id !== action.payload.settlementPriceId
      );
      state.error = null;
    });

    builder.addCase(deleteSettlementPrice.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete settlement price";
    });
  },
});

export default settlementPricesSlice.reducer;
